<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="650">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline">Pilih Sekolah Tugas</v-card-title>
        <v-card-text class="pt-2">
          <v-row no-gutters v-for="sekolah in sasarans" :key="sekolah.index" class="pa-2" @click="pilih(sekolah)">
            <v-col cols="2" sm="2" md="2" lg="2" xl="1" v-if="$vuetify.breakpoint.smAndUp">
              <div class="v-avatar primary" style="height: 55px; min-width: 55px; width: 55px;">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-school theme--light white--text" style="font-size: 30px;"></i>
              </div>
            </v-col>
            <v-col cols="10" sm="10" md="10" lg="10" xl="10">
              <div class="text-left mb-0 pb-0 black--text pt-2">
                <strong> {{ sekolah.nama }}</strong>
                <p :class="sekolah.is_terdaftar_diklat ? 'success--text' : 'warning--text'" outlined>
                  {{ sekolah.is_terdaftar_diklat ? "Terdaftar" : "Belum Mendaftar" }}
                </p>
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black--text" text @click="closeGuide">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature
export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false,
      sasarans: []
    };
  },

  methods: {
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open(val) {
      this.sasarans = [...val];
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    //@vuese
    //tutup dialog
    closeGuide() {
      this.dialog = false;
      this.resolve();
    },

    pilih(sekolah) {
      this.dialog = false;
      this.resolve(sekolah);
    }
  }
};
</script>
